import { getChartLabel } from "./chartLabel";
import { useState } from "react";
import { Form } from "react-bootstrap";

//kpi-17
const Status = ({ data, filters, selectedState }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderRadius: "8px",
          marginTop: "20px",
        }}
      >
        <h5 style={{ color: "#666", fontSize: "20px" }}>No data available</h5>
      </div>
    );
  }
  const meetData = data.map((item) => {
    return {
      place: item.Place,
      month:item.Month,
      complaints_officer_status: item.complaints_officer_status,
      complaints_officer_remarks: item.complaints_officer_remarks,
    };
  });

  const totalPages = Math.ceil(meetData.length / itemsPerPage);

  const currentData = meetData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const getPageNumbers = () => {
    const pageNumbers = [];
    const delta = 2;

    const range = [];
    for (
      let i = Math.max(2, currentPage - delta);
      i <= Math.min(totalPages - 1, currentPage + delta);
      i++
    ) {
      range.push(i);
    }

    if (currentPage - delta > 2) {
      pageNumbers.push("...");
    }

    pageNumbers.push(...range);

    if (currentPage + delta < totalPages - 1) {
      pageNumbers.push("...");
    }

    return [1, ...pageNumbers, totalPages];
  };

  const showMonth =
    !filters?.StartMonth && !filters?.EndMonth
      ? true // ✅ all months → show
      : filters?.StartMonth !== filters?.EndMonth;

  return (
    <div style={{ width: "100%", position: "relative" }}>
      <div className="card hptCard mt-4 border-0">
        <div class="card-header brBtomlr justify-content-between d-flex align-items-center">
          <h5 style={{ fontWeight: "bold" }}>
            Complaints Officer Status {getChartLabel(filters, selectedState)}
          </h5>
        </div>
      </div>

      <div className="card hptCard mt-4 border-0">
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead className="thead-light">
              <tr>
                <th className="fw-bold">Place</th>
                {showMonth && <th className="fw-bold">Month</th>}
                <th className="fw-bold text-center">Status</th>
                <th className="fw-bold text-center">Remarks</th>
              </tr>
            </thead>
            <tbody>
              {currentData.map((item, idx) => (
                <tr key={idx}>
                  <td style={{ fontWeight: "bold" }}>{item.place}</td>
                  {showMonth && <td>{item.month}</td>}
                  <td>{item.complaints_officer_status}</td>
                  <td>{item.complaints_officer_remarks}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {totalPages > 1 && (
          <div className="card-footer">
            <div className="d-flex justify-content-center mt-3">
              <nav>
                <ul className="pagination">
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                    >
                      &laquo;
                    </button>
                  </li>

                  {getPageNumbers().map((page, index) => (
                    <li
                      key={index}
                      className={`page-item ${
                        page === currentPage ? "active" : ""
                      } ${page === "..." ? "disabled" : ""}`}
                    >
                      <button
                        className="page-link"
                        onClick={() =>
                          typeof page === "number" && setCurrentPage(page)
                        }
                        disabled={page === "..."}
                      >
                        {page}
                      </button>
                    </li>
                  ))}

                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() =>
                        setCurrentPage((p) => Math.min(p + 1, totalPages))
                      }
                    >
                      &raquo;
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default Status;
